import React, { useEffect } from "react";
import "./Loader.scss";
import regbanner from "../../../assets/icons/progresslogo.png";
import { errorMessage } from "../../utils/errorMessage";
import { announce } from "./AccessibilityAnnouncer";
export interface ILoaderProps {
	color?: "grey" | "blue";
	size: 18 | 20 | 50 | 100;
	announce?: boolean;
}

const Loader: React.FC<ILoaderProps> = () => {
	useEffect(() => {
		announce(errorMessage.loaderMsg);
	}, []);
	return (
		<div
			className="loader-container"
			role="status"
			aria-live="polite"
			aria-busy="true"
		>
			<img src={regbanner} className="verified-img" alt="" aria-hidden="true" />
			<p className="loader-text">{errorMessage.loaderMsg}</p>
		</div>
	);
};

export default Loader;